<div
  class="bn-close-case-dialog flex flex-col gap-4"
  [attr.aria-busy]="caseSaving()"
>
  @if (caseSaving()) {
    <div role="status" class="flex items-center gap-2 text-sm">
      <i class="pi pi-spinner pi-spin" aria-hidden="true"></i>
      <span>Saving changes…</span>
    </div>
  }
  <header class="bn-close-case-dialog__header">
    <h2 class="bn-close-case-dialog__title m-0">Close this case</h2>
  </header>

  @if (store.isLive() && store.closedReasonsLoading()) {
    <div
      role="status"
      aria-label="Loading closure reasons"
      data-testid="closure-reasons-skeleton"
      class="flex gap-2"
    >
      <p-skeleton width="7rem" height="2rem" borderRadius="1rem" />
      <p-skeleton width="7rem" height="2rem" borderRadius="1rem" />
      <p-skeleton width="7rem" height="2rem" borderRadius="1rem" />
    </div>
  } @else {
    <div
      class="flex items-center gap-2 flex-wrap"
      role="radiogroup"
      aria-label="Closure reason"
    >
      @for (
        option of reasonOptions();
        track option.code;
        let i = $index;
        let first = $first
      ) {
        <button
          type="button"
          class="bn-close-case-dialog__reason"
          [class.bn-close-case-dialog__reason--selected]="
            reason() === option.code
          "
          role="radio"
          [attr.aria-checked]="reason() === option.code"
          [attr.tabindex]="
            reason() === option.code || (!reason() && first) ? 0 : -1
          "
          (click)="selectReason(option.code)"
          (keydown)="onReasonKeydown($event, i)"
        >
          {{ option.label }}
        </button>
      }
    </div>
  }
  @if (store.isLive() && store.closedReasonsError()) {
    <p role="alert">Closure reasons could not be loaded.</p>
    <button type="button" (click)="store.loadClosedReasons(true)">Retry</button>
  }
  @if (reasonError(); as error) {
    <p class="bn-close-case-dialog__error text-sm m-0">{{ error }}</p>
  }

  <div class="flex flex-col gap-1">
    <label for="ccd-note" class="bn-close-case-dialog__label">
      Reason for the change (optional)
    </label>
    <textarea
      id="ccd-note"
      pTextarea
      rows="3"
      maxlength="1000"
      [ngModel]="note()"
      (ngModelChange)="note.set($event)"
    ></textarea>
  </div>

  <footer class="flex items-center justify-end gap-3">
    <button
      type="button"
      class="bn-close-case-dialog__cancel"
      [disabled]="saving()"
      (click)="tryClose()"
    >
      Cancel
    </button>
    <p-button
      label="Close case"
      [rounded]="true"
      [loading]="saving()"
      [disabled]="!canSubmit()"
      (onClick)="confirmClose()"
    />
  </footer>
</div>

<p-confirmDialog />
